import { useQuery } from "@apollo/client";
import React from "react";
import Draggable from 'react-draggable'
import { Flex } from "rebass";
import { GET_PATIENT_BY_ID } from "../graphql/queries";
import { IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput } from "../graphql/types/queries/patient";
import styled from "styled-components";
import { TopBarVisit } from "./visit/TopBarVisit";

const VisitPageWrapper = styled(Flex)`
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #fdf5f2 0%,#b8d6f5 100%);
`
const Visit = ()=>{
  const { data: dataPatient, loading: loadingPatient } = useQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID, {
    variables: {
      id: '2179'
    }
  })
   
  return <VisitPageWrapper>
    <TopBarVisit data={dataPatient} loading={loadingPatient} />
  </VisitPageWrapper>
}

export default Visit
